import { Box, Button, TextField } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../COMPONENTS/header/Header";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../../../CONTEXT/AuthProvider";

const ResetPassword = () => {
  const { auth } = useContext(AuthContext);
  const accessToken = auth.accessToken;

  const isNonMobile = useMediaQuery("(min-width:600px)");
  const location = useLocation();

  const handleFormSubmit = async (values) => {
    if (values.password !== values.confirmPassword) {
      toast.error("Password and confirm password should match!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      const id = location.state.resetPassword.id;
      const password = values.password;
      try {
        const data = {
          password,
          id
        };

        await axios.post("/api/reset-password", data, {
          headers: {
            'Authorization': 'Bearer ' + accessToken
          }
        });
        toast.success("Password reset successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      } catch (err) {
        console.log(err);
      }
    }
  };

  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="20px">
          <Header
            title="RESET PASSWORD"
            subtitle="Reset user's password in the system"
          />

          <Formik
            onSubmit={handleFormSubmit}
            initialValues={initialValues}
            validationSchema={checkoutSchema}
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleChange,
              handleSubmit,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap="30px"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <TextField
                    fullWidth
                    variant="filled"
                    type="password"
                    label="Password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.password}
                    name="password"
                    error={!!touched.password && !!errors.password}
                    helperText={touched.password && errors.password}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="password"
                    label="Confirm Password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.confirmPassword}
                    name="confirmPassword"
                    error={
                      !!touched.confirmPassword && !!errors.confirmPassword
                    }
                    helperText={
                      touched.confirmPassword && errors.confirmPassword
                    }
                    sx={{ gridColumn: "span 2" }}
                  />
                </Box>
                <Box display="flex" justifyContent="end" mt="20px">
                  <Button type="submit" color="success" variant="contained">
                    Reset Password
                  </Button>
                </Box>
                <ToastContainer />
              </form>
            )}
          </Formik>
        </Box>
      </main>
    </div>
  );
};

const checkoutSchema = yup.object().shape({
  password: yup.string().required("required"),
  confirmPassword: yup.string().required("required"),
});
const initialValues = {
  password: "",
  confirmPassword: "",
};

export default ResetPassword;
